import {
  Pipe,
  PipeTransform
} from '@angular/core';

/**
 * Formats a number as Indian-style currency: ₹ with lakhs/crores grouping (...,XX,XX,XXX)
 * on the integer part only; rounds to 2 decimal places and avoids float artifacts in the display.
 */
@Pipe({
  name: 'indianCurrency'
})
export class IndianCurrency implements PipeTransform {
  transform(value: any): string {
    if (value == null || value === '') {
      return '₹ 0.00';
    }
    const num = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (typeof num !== 'number' || isNaN(num)) {
      return '₹ 0.00';
    }

    const rounded = Math.round((num + Number.EPSILON) * 100) / 100;
    const fixed = rounded.toFixed(2);
    const [intRaw, decPart] = fixed.split('.');
    const negative = intRaw.startsWith('-');
    const absInt = negative ? intRaw.slice(1) : intRaw;
    const groupedInt = this.formatIndianInteger(absInt);

    const sign = negative ? '-' : '';
    return `₹ ${sign}${groupedInt}.${decPart}`;
  }

  /** Indian numbering: last 3 digits, then groups of 2 from the left remainder. */
  private formatIndianInteger(absInt: string): string {
    if (!absInt || absInt === '0') {
      return absInt || '0';
    }
    if (absInt.length <= 3) {
      return absInt;
    }
    const lastThree = absInt.slice(-3);
    let rest = absInt.slice(0, -3);
    const segments: string[] = [lastThree];
    while (rest.length > 2) {
      segments.unshift(rest.slice(-2));
      rest = rest.slice(0, -2);
    }
    if (rest.length > 0) {
      segments.unshift(rest);
    }
    return segments.join(',');
  }
}
